import React from "react";
import { Accordion } from "react-bootstrap";
import CoiCertificateLanguageToggle from "../COI/CoiCertificateLanguageToggle";
import { VIEW_ONLY_EMPTY_MESSAGE } from "../../hooks/useAdminPermissions";

const formatProductStatus = (status) => {
  if (!status) {
    return "-";
  }

  const normalized = String(status).toLowerCase();
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};

const getFaqQuestions = (content, manageSwitch) => {
  const questions = manageSwitch
    ? content?.spanish?.questions
    : content?.english?.questions;

  return (questions || []).filter(
    (item) => item?.question?.trim() || item?.answer?.trim(),
  );
};

const FaqViewOnly = ({
  productName = "-",
  productCode = "-",
  productStatus = "",
  content,
  manageSwitch,
  setManageSwitch,
}) => {
  const questions = getFaqQuestions(content, manageSwitch);

  return (
    <>
      <div className="product-view-info mb-30">
        <div className="product-view-info-field">
          <p className="product-view-info-label">Product Name</p>
          <p className="product-view-info-value">{productName}</p>
        </div>
        <div className="product-view-info-divider" aria-hidden="true" />
        <div className="product-view-info-field">
          <p className="product-view-info-label">Product Code</p>
          <p className="product-view-info-value">{productCode}</p>
        </div>
        <div className="product-view-info-divider" aria-hidden="true" />
        <div className="product-view-info-field">
          <p className="product-view-info-label">Product Status</p>
          <p className="product-view-info-value">
            {formatProductStatus(productStatus)}
          </p>
        </div>
      </div>

      <div className="d-flex justify-content-end mb-30">
        <CoiCertificateLanguageToggle
          manageSwitch={manageSwitch}
          setManageSwitch={setManageSwitch}
        />
      </div>

      {questions.length > 0 ? (
        <Accordion defaultActiveKey="0" className="faq-view-only-accordion">
          {questions.map((item, index) => (
            <Accordion.Item eventKey={String(index)} key={`${item?.question}-${index}`}>
              <Accordion.Header>{item?.question}</Accordion.Header>
              <Accordion.Body>{item?.answer}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      ) : (
        <div className="sectionpadding bg-white mb-30 faq-view-only-panel">
          <p className="release-document-view-empty mb-0">
            {VIEW_ONLY_EMPTY_MESSAGE}
          </p>
        </div>
      )}
    </>
  );
};

export default FaqViewOnly;
